import { defineTabs } from '@/features/admin/shared/tabs';

/**
 * Constantes partagées des écrans de facturation (hors des `.tsx`, pour que le rechargement à
 * chaud de Vite garde les composants seuls dans leurs fichiers).
 */

/**
 * Garde des gestes : `/tenant/admin`, comme le backend (`PaymentMethodManager`,
 * `TransactionManager#asTenantAdministrator`). Lectures comprises : un membre ordinaire reçoit 403.
 */
export const billingGuard = (tenantId: string) => ({
  permission: '/tenant/admin',
  resource: { type: 'tenant', id: tenantId },
});

/** Codes du contrat qui ont un texte traduit (`billing.paymentMethods.errors.<CODE>`). */
export const PAYMENT_METHOD_CODES = ['CAN_NOT_DELETE_FAVORITE', 'CAN_NOT_SET_FAVORITE'] as const;

export const INVOICE_TABS = defineTabs(['summary', 'transactions'] as const);
export type InvoiceTab = (typeof INVOICE_TABS.ids)[number];

export const TRANSACTION_TABS = defineTabs(['summary'] as const);
export type TransactionTab = (typeof TRANSACTION_TABS.ids)[number];

/** Ce que la console sait ajouter avec le fournisseur `manual` (`?kind=` de l'écran d'ajout). */
export const NEW_PAYMENT_KINDS = ['sepa', 'transfer'] as const;
export type NewPaymentKind = (typeof NEW_PAYMENT_KINDS)[number];
export const parseNewPaymentKind = (value: unknown): NewPaymentKind =>
  value === 'transfer' ? 'transfer' : 'sepa';
